/*
    This way we can have a single source of truth for the keys and the values.
    From my experience, it's better to have a single source of truth for the keys, so if we need to change the key, we can do it in a single place.
*/

export class LocalStorageManager<T extends Record<string, string>> {
  private readonly _namespace: string;
  private readonly _keys: T;

  constructor(namespace: string, keys: T) {
    this._namespace = namespace;
    this._keys = keys;
  }

  public getFullKey(name: keyof T): string {
    return `${this._namespace}:${this._keys[name]}`;
  }

  public flag(name: keyof T, defaultValue: boolean = true): boolean {
    return defaultValue
      ? localStorage.getItem(this.getFullKey(name)) !== 'false'
      : localStorage.getItem(this.getFullKey(name)) === 'true';
  }

  public has(name: keyof T): boolean {
    return localStorage.getItem(this.getFullKey(name)) !== null;
  }

  public get(name: keyof T): string | null {
    return localStorage.getItem(this.getFullKey(name));
  }

  public set(name: keyof T, value: string): void {
    localStorage.setItem(this.getFullKey(name), value);
  }

  public remove(name: keyof T): void {
    localStorage.removeItem(this.getFullKey(name));
  }
}
